import React, { useState } from 'react';
import { B } from '../../constants';

const PencilIcon = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 20h9" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
  </svg>
);

const TrashIcon = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const VARIANTS = {
  edit: { Icon: PencilIcon, color: B.night, hoverBg: '#f0f4f2', hoverBorder: B.forest, label: 'Edit' },
  delete: { Icon: TrashIcon, color: '#dc3545', hoverBg: '#fdecea', hoverBorder: '#dc3545', label: 'Delete' },
};

const SIZES = { sm: { box: 30, icon: 14 }, md: { box: 36, icon: 16 } };

// Square icon-only action button with consistent size + hover across screens.
// `label` is required for a11y (aria-label + tooltip).
export default function IconButton({ variant = 'edit', size = 'md', label, onClick, disabled = false, style, ...rest }) {
  const [hover, setHover] = useState(false);
  const v = VARIANTS[variant] || VARIANTS.edit;
  const s = SIZES[size] || SIZES.md;
  const text = label || v.label;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={text}
      title={text}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        width: s.box,
        height: s.box,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
        borderRadius: 8,
        border: `1px solid ${hover && !disabled ? v.hoverBorder : '#ddd'}`,
        background: hover && !disabled ? v.hoverBg : 'white',
        color: v.color,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'background 0.15s ease, border-color 0.15s ease',
        ...style,
      }}
      {...rest}
    >
      <v.Icon size={s.icon} />
    </button>
  );
}
